export interface TradeInModelYearStateModel {
  isLoading: boolean;
  modelsYears: string[];
}
export const initialStateTradeInModelYear: TradeInModelYearStateModel = {
  isLoading: false,
  modelsYears: [],
};
